import FrequentlyBoughtProductsCarousel from './FrequentlyBoughtProductsCarousel';
export default FrequentlyBoughtProductsCarousel;
